module.exports = __webpack_public_path__ + "static/media/workshop-table.b2aec103.png";